import React, { useState, useEffect } from 'react';
import { useAppState } from '../context/State';
import { GetCopy } from '../util/GetCopy';
import Select from 'react-select';

const Dropdown = ({ selectedFormat, setSelectedFormat, setNextAdIndex }) => {
  const state = useAppState();
  const [uniqueFormats, setUniqueFormats] = useState(null);

  const [selectedLabel, updateSelectedLabel] = useState(<GetCopy copy="all" />);

  const handleSelectChange = (event) => {
    setNextAdIndex(9);
    setSelectedFormat(event.value);
    updateSelectedLabel(event.label);
  };
  
  useEffect(() => {
    setSelectedFormat('All');
    updateSelectedLabel(<GetCopy copy="all" />);
    if (state.activeOption === 'Display') {
      let formats = state.adData.map((item) => item.custom_fields)
      formats = formats.map(fmat=> fmat.filter(f => f.name === "Format")?.[0]);
      formats = formats.filter(f => f.name === "Format").map(f => f.type_config.options[f.value]?.name).filter(Boolean);

      setUniqueFormats([...new Set(formats)]);
    } else {
      let formats = state.videoData.map((item) => item.custom_fields)
      formats = formats.map(fmat=> fmat.filter(f => f.name === "Format")?.[0]);
      formats = formats.filter(f => f.name === "Format").map(f => f.type_config.options[f.value]?.name).filter(Boolean);

      setUniqueFormats([...new Set(formats)]);
    }
  }, [state.activeOption]);
  const formats = uniqueFormats;

  const options = formats && [
    { value: 'All', label: <GetCopy copy="all" /> },
    ...formats.map((format) => ({ value: format, label: format })),
  ];

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      border: 0,
      boxShadow: 'none',
      cursor: 'pointer',
    }),
    container: (styles) => ({ ...styles, maxWidth: '290px' }),
    menu: (styles) => ({ ...styles, backgroundColor: 'white' }),

    indicatorSeparator: (styles) => ({ ...styles, display: 'none' }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: 'white',
        color: 'blacks',
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        focus: 'none',
      };
    },
  };

  const MyComponent = () =>
    (options && (
      <Select
        styles={colourStyles}
        options={options}
        isSearchable={false}
        onChange={handleSelectChange}
        components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
        defaultValue={{
          value: selectedFormat,
          label: (
            <div>
              {selectedLabel}
              <img src="/wp-content/themes/criteo2017/img/down.svg" className="labelArrow" />
            </div>
          ),
        }}
      />
    )) ||
    null;
  return (
    <div>
      <MyComponent />
    </div>
  );
};

export default Dropdown;
